export default function AIRecommendationIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_35566_69654)'>
        <path
          d='M8.27696 12.9162C8.20256 12.6278 8.05224 12.3646 7.84164 12.154C7.63104 11.9434 7.36785 11.7931 7.07946 11.7187L1.96696 10.4004C1.87973 10.3756 1.80297 10.3231 1.7483 10.2508C1.69364 10.1784 1.66406 10.0902 1.66406 9.99956C1.66406 9.90889 1.69364 9.82069 1.7483 9.74835C1.80297 9.67601 1.87973 9.62348 1.96696 9.59872L7.07946 8.27956C7.36775 8.20523 7.63087 8.05503 7.84146 7.84459C8.05205 7.63414 8.20243 7.37113 8.27696 7.08289L9.59529 1.97039C9.6198 1.88282 9.67228 1.80567 9.74473 1.75072C9.81717 1.69576 9.90561 1.66602 9.99654 1.66602C10.0875 1.66602 10.1759 1.69576 10.2484 1.75072C10.3208 1.80567 10.3733 1.88282 10.3978 1.97039L11.7153 7.08289C11.7897 7.37128 11.94 7.63447 12.1506 7.84507C12.3612 8.05567 12.6244 8.20599 12.9128 8.28039L18.0253 9.59789C18.1132 9.62214 18.1907 9.67456 18.246 9.74712C18.3012 9.81968 18.3312 9.90836 18.3312 9.99956C18.3312 10.0908 18.3012 10.1794 18.246 10.252C18.1907 10.3245 18.1132 10.377 18.0253 10.4012L12.9128 11.7187C12.6244 11.7931 12.3612 11.9434 12.1506 12.154C11.94 12.3646 11.7897 12.6278 11.7153 12.9162L10.397 18.0287C10.3725 18.1163 10.32 18.1934 10.2475 18.2484C10.1751 18.3033 10.0866 18.3331 9.99571 18.3331C9.90478 18.3331 9.81634 18.3033 9.74389 18.2484C9.67145 18.1934 9.61896 18.1163 9.59446 18.0287L8.27696 12.9162Z'
          stroke='CurrentColor'
          stroke-width='1.66667'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M16.6641 2.5V5.83333'
          stroke='CurrentColor'
          stroke-width='1.66667'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M18.3333 4.16602H15'
          stroke='CurrentColor'
          stroke-width='1.66667'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M3.33594 14.166V15.8327'
          stroke='CurrentColor'
          stroke-width='1.66667'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M4.16667 15H2.5'
          stroke='CurrentColor'
          stroke-width='1.66667'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_35566_69654'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
